import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import Button from '../../elements/Button';
import TextField from '../../fields/Text';

import PasswordField from '../../fields/Password';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import styles from './styles.scoped.css';
import IconWarning from '../../icons/IconWarning';
import Banner from '../../elements/Banner';
import IconFailed from '../../icons/IconFailed';
export default function Login({
  change = () => { },
  handleSubmit = () => { },
  invalid = true,
  onClearError = () => { },
  onLoginIdaman = () => { },
  toggleOpenForgotPassword = () => { },
}) {
  const { isLoading, message, code } = useSelector((s) => s.login);
  // const { values } = useSelector((s) => s.form.login || { values: {} });

  const btnDisabled = isLoading || invalid;
  const usernameProps = {
    placeholder: 'Masukkan email Anda',
    label: 'Email',
    icon: 'ic-email-2.svg',
  };
  const passwordProps = {
    placeholder: 'Masukkan kata sandi Anda',
    label: 'Password',
    icon: 'ic-lock-2.svg',
  };
  const isShowMessageError =
    message && code !== 200 && !(code === 400 && message.includes('expired'));

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = useCallback(
    (e) => {
      e.preventDefault();
      if (!executeRecaptcha) {
        return;
      }
      (async () => {
        const token = await executeRecaptcha('login');
        change('token', token);
        setTimeout(() => {
          handleSubmit(e);
        }, 100);
      })();
    },
    [executeRecaptcha]
  );

  return (
    <form className={styles.root} onSubmit={(e) => handleReCaptchaVerify(e)}>
      {isShowMessageError && (
        <Banner desc={message} icon={<IconFailed />} type={'danger'} />
      )}
      <Field
        component={TextField}
        errorIcon={
          <IconWarning className={styles['error-icon']} color="#CF212A" />
        }
        inputProps={usernameProps}
        isErrorField={isShowMessageError}
        name="username"
        onChange={onClearError}
      />
      <Field component="input" name="token" type="hidden" />
      <small>Contoh format email: user@email.com</small>
      <Field
        component={PasswordField}
        errorIcon={
          <IconWarning className={styles['error-icon']} color="#CF212A" />
        }
        inputProps={passwordProps}
        isErrorField={isShowMessageError}
        name="password"
        onChange={onClearError}
      />
      <Button
        className={styles.link}
        onClick={() => toggleOpenForgotPassword(true)}
        type="button"
      >
        Lupa Kata Sandi?
      </Button>
      <footer>
        <Button
          disabled={btnDisabled}
          eventName="login"
          fullWidth
          style={'blue'}
          type="submit"
        >
          {isLoading ? 'Mengirim...' : 'Masuk'}
        </Button>
        <div className={styles.divider}>
          <span>atau</span>
        </div>
        <Button
          className={styles['btn-idaman']}
          fullWidth
          onClick={onLoginIdaman}
          style={'outlined'}
          type="button"
        >
          Masuk dengan IdAMan <img alt="IdAMan" className={styles['idaman-icon']} src="/assets/idaman.png" />
        </Button>
      </footer>
    </form>
  );
}

Login.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  onClearError: PropTypes.func,
  onLoginIdaman: PropTypes.func,
  toggleOpenForgotPassword: PropTypes.func,
};
